import { render, staticRenderFns } from "./HeaderAdsApp.vue?vue&type=template&id=0ef2ceef"
import script from "./HeaderAdsApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderAdsApp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports